import styled from 'styled-components'
import { media } from '../../utilities/styled'
import Column from '../../primitives/column'
import Row from '../../primitives/row'
import Icon from '../../primitives/icon'
import Image from '../../primitives/image'
import Text from '../../primitives/text'
import ExternalLink from '../../primitives/external-link'

export const FullWidthRow = styled(Row)`
  &,
  > * {
    max-width: none;
  }
`

export const FootRow = styled(FullWidthRow)`
  max-width: none;
  padding-bottom: 34px;
  padding-top: 34px;
  position: relative;
`

export const FootRowInner = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
`

export const AddressRow = styled.div`  
  color:#ccc;
  margin-bottom: 15px;
`

export const CookieRow = styled.div`  
margin-top: 10px;
`

export const FootTextColumn = styled(Column)`
  ${media.tablet`
    flex: 1 100%;
   `}
`

export const LanguageRow = styled(FullWidthRow)`
  align-items: center;
  padding-bottom: 20px;
  padding-top: 20px;

  ${media.phone`
    padding-bottom: 25px;
    text-align: center;
  `};
`

export const LanguageColumn = styled(Column)`
  flex-direction: row;
  align-items: center;

  ${media.tablet`
    flex: 1 100%;
    flex-direction: column;
    justify-content: center;
  `};
`

export const LanguageText = styled(Text)`
  margin-right: 1rem;
`

export const LanguageSelectContainer = styled.span`
  display: flex;
  flex-direction: row;

  ${media.tablet`
    justify-content: center;
    margin-top: 6px;
  `};
`

export const NavigationRow = styled(Row)`
  margin-bottom: 80px;
  margin-top: 20px;

  &,
  > * {
    max-width: none;
  }

  ${media.phone`
    margin-bottom: 50px;
    margin-top: 50px;
  `};
`

export const NavigationColumn = styled(Column)`
  ${media.phone`
    &:not(:last-child) {
      margin-bottom: 25px;
    }
  `};
`

export const SocialColumn = styled(Column)`
  flex-direction: row;
  justify-content: flex-end;
  width:100%;

  > a {
    margin-left: 5px;

    :first-child {
      margin-left: 0;
    }
  }

  ${media.tablet`
    flex: 1 100%;
    justify-content: center;
    margin-top: 40px;
  `};
`

export const SocialIcon = styled(Icon)``

export const SecurePaymentColumn = styled(Column)`
  flex-direction: row;
  padding-bottom: 40px;
  padding-top: 70px;

  ${media.tablet`
    padding-bottom: 25px;
    padding-top: 25px;
  `};
`

export const FootLinkText = styled(ExternalLink)`
  display: inline-block;
  margin-right: 40px;
  ${media.tablet`
    display: block;
    float: left;
    margin-bottom: 5px;
  `};
`

export const RelxGroup = styled(Image)`
  margin-left: auto;  
  margin-bottom: 8px;
  width: 110px;
`

export const BeianIco = styled(Image)`
vertical-align: middle;
`

export const Wordmark = styled(Image)`  
  margin-right: auto;  
  margin-left: auto;
`

export const WordmarkColumn = styled(Column)`
  ${media.tablet`
    margin-top: 40px;
    order: 1;
    flex: 1 40%;
  `};
`
